<script>
  import Painting from "./Painting.svelte";
  import * as gallery from "../data/gallery_images_data.js";

  const images = gallery.images

</script>


<div id="gallery" class="section">
    <div class="container"> 
        <div class="row">
            {#each images as img, idx}
                <div class="col s4 m4 l4">
                    <Painting {img}/>
                </div>
                {#if idx % 3 === 2 }
                    <div class="divider"></div>
                {/if}
            {/each}  
        </div>
    </div>
</div>


<style>

    #gallery{ background-color: #efebe9; }
    .row .col { padding: 0 !important; }    
    .divider {height: 0 !important; }
    
</style>
